import React, { memo } from 'react';
import PropTypes from 'prop-types';
import BaseContactBox from './BaseContactBox';

const ContactMailBox = memo(({ value }) => {
  const linkHref = `mailto:${value}`;

  return (
    <BaseContactBox {...{ linkHref, value }} classNames="contact-box--email" />
  );
});

ContactMailBox.displayName = 'ContactMailBox';

ContactMailBox.propTypes = {
  value: PropTypes.string.isRequired
};

export default ContactMailBox;
